// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c293498f","455":"17a73ea3","828":"945e901f","857":"68553637","977":"f610ad32"}[chunkId] + ".chunk.js";
};